"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFormLabel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Lock_1 = __importDefault(require("@mui/icons-material/Lock"));
const material_1 = require("@mui/material");
const AdapterDayjs_1 = require("@mui/x-date-pickers/AdapterDayjs");
const DatePicker_1 = require("@mui/x-date-pickers/DatePicker");
const LocalizationProvider_1 = require("@mui/x-date-pickers/LocalizationProvider");
const react_query_1 = require("@tanstack/react-query");
const dayjs_1 = __importDefault(require("dayjs"));
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const react_router_1 = require("react-router");
const react_use_1 = require("react-use");
const appConstants_1 = require("../../../constants/appConstants");
const strings_1 = require("../../../constants/strings");
const uiConstants_1 = require("../../../constants/uiConstants");
const approvalQuery_1 = require("../../../queries/approvals/approvalQuery");
const codingQuery_1 = require("../../../queries/codingQuery");
const companyQuery_1 = require("../../../queries/companyQuery");
const featureQuery_1 = require("../../../queries/featureQuery");
const teamQuery_1 = require("../../../queries/teamQuery");
const userQuery_1 = require("../../../queries/userQuery");
const codingRepository_1 = __importDefault(require("../../../repositories/codingRepository"));
const Root_1 = require("../../../router/Root");
const zustandStore_1 = require("../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../atoms/button/simpleButton"));
const purchaseRequestForm_1 = require("../../pages/request/newRequest/purchaseRequestForm");
const requestDetail_1 = __importDefault(require("../../pages/request/newRequest/requestDetail"));
const drawerAside_1 = __importDefault(require("../drawerAside"));
exports.StyledFormLabel = (0, material_1.styled)(material_1.FormLabel)(({ theme }) => ({
    fontWeight: theme.typography.tsFontWeight.bold,
    fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.mini),
    lineHeight: '30px',
    textTransform: 'uppercase',
    ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
        ? {
            fontWeight: 500,
            color: '#000000',
            textTransform: 'none',
        }
        : {}),
}));
function normalizeCodingEntry(codingEntry) {
    // TODO: existing coding entries use ID, so let's use entryId and rename later
    const entryId = codingEntry.ID || codingEntry.entryId;
    const entryLabel = codingEntry.path || codingEntry.entryLabel;
    return Object.assign({}, codingEntry, { entryId, entryLabel });
}
const mapTeamCodingLists = lists => {
    if (!lists) {
        return [];
    }
    return lists?.reduce((output, { entries: rawEntries, ID: listId, name: label }) => {
        const entries = rawEntries?.map(({ entryId, entryLabel, filteredBy }) => {
            return { entryId, filteredBy, listId, label: entryLabel };
        });
        output[listId] = { entries, label, listId };
        return output;
    }, {});
};
const decorateCodingLists = codingLists => {
    if (!codingLists) {
        return [];
    }
    const mappedList = mapTeamCodingLists(codingLists);
    const decoratedLists = { ...mappedList };
    Object.entries(decoratedLists)?.forEach(([listId, { entries, label: listLabel }]) => {
        entries?.forEach(entry => {
            Object.assign(entry, { listId, listLabel });
        });
    });
    return decoratedLists;
};
const mapCoding = coding => {
    return lodash_1.default.reduce(coding, (result, value, key) => {
        result[key] = {
            ID: value.ID,
            listId: value.listId,
            listLabel: value.listLabel,
            path: value.path,
        };
        return result;
    }, {});
};
const CreateCardAside = () => {
    const params = (0, react_router_1.useParams)();
    const [maxDate, setMaxDate] = (0, react_1.useState)((0, dayjs_1.default)().add(4, 'year'));
    const [activeLists, setActiveLists] = (0, react_1.useState)([]);
    const { data: userData } = (0, react_query_1.useQuery)(userQuery_1.userQuery);
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)((0, companyQuery_1.companyPropertiesQuery)(userData?.companyAccountId, {
        cardprovider: 'tsgo-cardprovider',
        defaultExpirationDate: 'tsgo-virtualcardexprange',
    }));
    const virtualCardExpRange = companyPropertiesData?.[purchaseRequestForm_1.virtualCardType] || 0;
    const cardProvider = companyPropertiesData?.cardprovider;
    const isHsbcCardProvider = cardProvider === 'HSBC';
    const [dateMessage, setDateMessage] = (0, react_1.useState)(purchaseRequestForm_1.maxDateMessage);
    const [purchaseRequest, setPurchaseRequest] = (0, react_1.useState)({});
    const [isDateValid, setIsDateValid] = (0, react_1.useState)(true);
    const { approvals, setIsCreateCardSuccessful, setApprovalRequest, setPageLoading, setNotification, setIsCreateCardAsideOpen, aside, } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const { approvalRequest } = approvals;
    const { createCardAside } = aside;
    const { approval, isOpen } = createCardAside;
    const teamId = approval?.request?.teamId || '';
    const { data: requestTeamData } = (0, teamQuery_1.useGetTeamQuery)({ teamId: teamId || '' });
    const isTeamCardCreationPaused = requestTeamData?.properties?.PAUSE_VIRTUAL_CARD_CREATION === 'true';
    const submitApprovalQuery = (0, approvalQuery_1.useSubmitApprovalMutationQuery)();
    const { data: features = {} } = (0, react_query_1.useQuery)(featureQuery_1.featuresQuery);
    const { data: activeCodingLists = [] } = (0, react_query_1.useQuery)((0, codingQuery_1.getCodingListsQuery)({ skipDisabled: true }));
    const options = {
        cardSources: requestTeamData?.sourceCards?.filter(card => card?.status === 'ACTIVE') || [],
        codingLists: decorateCodingLists(activeLists) || [],
        cardTypes: appConstants_1.cardTypes,
    };
    const minSelectableDate = (0, dayjs_1.default)(approval?.context?.request?.fields?.endDate);
    const [endDateInputValue, setEndDateInputValue] = (0, react_1.useState)(purchaseRequest?.request?.fields?.endDate);
    (0, react_1.useEffect)(() => {
        if (minSelectableDate.isValid() && minSelectableDate !== endDateInputValue) {
            setEndDateInputValue(minSelectableDate);
        }
    }, [approval]);
    (0, react_use_1.useDeepCompareEffect)(() => {
        if (!approval) {
            return;
        }
        const fields = lodash_1.default.get(approval, 'context.request.fields');
        setPurchaseRequest(approval?.request && {
            ...approval,
            request: {
                ...approval.request,
                profileId: lodash_1.default.get(approval, 'context.request.profileId', 'default'),
                fields: fields || {
                    amount: approval?.context?.request?.fields?.amount,
                    comments: approval?.context?.request?.fields?.comments || '',
                    description: approval?.request?.title,
                    endDate: minSelectableDate.format(purchaseRequestForm_1.DATE_FORMAT),
                },
                coding: approval?.context?.request?.coding,
            },
        });
    }, [approval, minSelectableDate]);
    (0, react_1.useEffect)(() => {
        if (!options && !purchaseRequest) {
            return;
        }
        initializeApproval();
    }, [purchaseRequest, options?.cardSources?.length]);
    (0, react_1.useEffect)(() => {
        const getListEntries = async () => {
            const updatedList = activeCodingLists.map(async (list) => {
                const { ID: listId } = list;
                if (teamId) {
                    const teamEntries = await codingRepository_1.default.getTeamCodingListEntries({ teamId, listId });
                    const newEntries = teamEntries?.map(entry => normalizeCodingEntry(entry));
                    return lodash_1.default.isEmpty(newEntries) ? null : { ...list, entries: newEntries };
                }
                else {
                    return null;
                }
            });
            if (!lodash_1.default.isEmpty(updatedList)) {
                void Promise.all(updatedList).then(function (results) {
                    const filteredList = results?.filter(list => !lodash_1.default.isEmpty(list?.entries));
                    setActiveLists([...filteredList]);
                });
            }
        };
        void getListEntries();
    }, [activeCodingLists, teamId]);
    function initializeApproval() {
        setApprovalRequest({
            ...approvalRequest,
            cardSourceId: options?.cardSources?.length > 0 ? options?.cardSources[0]?.id || '' : '',
            cardType: options?.cardTypes.find(card => card?.cardType === purchaseRequest?.request?.cardType)?.cardType ||
                'multiple-use',
            coding: purchaseRequest?.request?.coding,
            requesterUserId: purchaseRequest?.assigner,
            requestId: purchaseRequest?.request?.requestId,
            taskId: purchaseRequest?.id,
            eventId: crypto.randomUUID(),
            endDate: approval?.context?.request?.fields?.endDate,
        });
    }
    const submit = () => {
        setIsCreateCardSuccessful(true);
        const endDate = (() => {
            const parts = approvalRequest?.endDate.split('-');
            if (parts.length === 3) {
                const [first, second, third] = parts;
                if (third.length === 4) {
                    // if the last part is a 4-digit year, rearrange to YYYY-MM-DD
                    return `${third}-${second}-${first}`;
                }
            }
            return approvalRequest.endDate;
        })();
        const data = {
            ...approvalRequest,
            coding: mapCoding(approvalRequest?.coding),
            endDate,
        };
        const selectedCardSource = options?.cardSources?.find(card => card.id === data.cardSourceId);
        if (selectedCardSource?.status === 'IN_PROGRESS') {
            setNotification([
                {
                    type: strings_1.notificationStrings.ERROR,
                    message: "We couldn't create the virtual card since the " +
                        (globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'physical' : 'parent') +
                        ' card enrollment has not completed. ' +
                        'Please contact your bank to resolve and try again.',
                },
            ]);
            setIsCreateCardSuccessful(false);
            return;
        }
        setPageLoading(true);
        submitApprovalQuery.mutate(data, {
            onSuccess: () => {
                if (params?.['approvalId']) {
                    setIsCreateCardSuccessful(true);
                }
            },
            onError: () => {
                if (params?.['approvalId']) {
                    setIsCreateCardSuccessful(false);
                }
            },
            onSettled: () => {
                if (params?.['approvalId']) {
                    void Root_1.queryClient.invalidateQueries({
                        queryKey: ['approval', params?.['approvalId']],
                    });
                }
                setPageLoading(false);
            },
        });
        setIsCreateCardAsideOpen(false);
    };
    const populateDates = () => {
        const { ENABLE_VIRTUAL_CARD_EXP_RANGE } = features;
        let endDate;
        if (ENABLE_VIRTUAL_CARD_EXP_RANGE) {
            const virtualCardExpRangeInMonths = virtualCardExpRange / 30;
            endDate = (0, dayjs_1.default)().add(virtualCardExpRangeInMonths, 'month');
        }
        else {
            endDate = isHsbcCardProvider ? (0, dayjs_1.default)().add(1, 'year') : (0, dayjs_1.default)().add(48, 'month');
        }
        if (endDate.format(purchaseRequestForm_1.DATE_FORMAT) !== maxDate) {
            setMaxDate(endDate.format(purchaseRequestForm_1.DATE_FORMAT));
        }
        if (ENABLE_VIRTUAL_CARD_EXP_RANGE) {
            const rangeObj = appConstants_1.virtualCardExpRanges.find(range => range.id === virtualCardExpRange);
            const rangeMessage = lodash_1.default.get(rangeObj, 'label', 'a date');
            setDateMessage(`Up to ${rangeMessage} in the future`);
        }
    };
    (0, react_use_1.useDeepCompareEffect)(() => {
        populateDates();
    }, [features, virtualCardExpRange, isHsbcCardProvider]);
    function isFormInvalid() {
        const isEndDateInvalid = !(0, dayjs_1.default)(endDateInputValue, purchaseRequestForm_1.DATE_FORMAT, false).isValid();
        if (isEndDateInvalid) {
            return true;
        }
        else if (Object.keys(options?.codingLists)?.length) {
            if (!approvalRequest?.coding) {
                return true;
            }
            else if (approvalRequest?.coding &&
                (Object.keys(approvalRequest?.coding)?.length === 0 ||
                    (Object.keys(approvalRequest?.coding)?.length > 0 &&
                        Object.keys(approvalRequest?.coding)?.filter(codingListName => approvalRequest?.coding[codingListName]?.ID)
                            ?.length === Object.keys(options?.codingLists)?.length))) {
                return false;
            }
            else {
                return true;
            }
        }
        else {
            return false;
        }
    }
    const asideContent = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(requestDetail_1.default, { requestForApproval: purchaseRequest?.request, style: {
                    ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? {
                            border: '1px solid #979797',
                            marginTop: '10px',
                        }
                        : {}),
                } }), (0, jsx_runtime_1.jsxs)(material_1.FormGroup, { style: {
                    margin: '0',
                    justifyContent: 'space-between',
                    paddingTop: '20px',
                    flex: '1 1 0%',
                    padding: '20px 0 0',
                }, children: [(0, jsx_runtime_1.jsxs)(material_1.FormControl, { style: {
                            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    paddingBottom: '10px',
                                }
                                : {}),
                        }, children: [(0, jsx_runtime_1.jsx)(exports.StyledFormLabel, { children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'Physical card' : 'Parent Card' }), (0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "select-card", required: true, value: approvalRequest.cardSourceId || '', inputProps: {
                                    placeholder: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                        ? 'Select Physical Card'
                                        : 'Select Parent Card',
                                }, onChange: event => setApprovalRequest({
                                    ...approvalRequest,
                                    cardSourceId: event?.target?.value,
                                }), children: options?.cardSources?.map(cardOption => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: cardOption?.id, children: cardOption.label }, cardOption?.id))) })] }), (0, jsx_runtime_1.jsxs)(material_1.FormControl, { style: {
                            ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                ? {
                                    paddingBottom: '10px',
                                }
                                : {}),
                        }, children: [(0, jsx_runtime_1.jsx)(exports.StyledFormLabel, { children: "Virtual Card Type" }), (0, jsx_runtime_1.jsx)(material_1.Select, { "data-testid": "select-virtual-card", readOnly: true, required: true, value: approvalRequest.cardType || '', inputProps: {
                                    IconComponent: () => null,
                                    placeholder: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                        ? 'Select Physical Card'
                                        : 'Select Parent Card',
                                }, endAdornment: (0, jsx_runtime_1.jsx)(Lock_1.default, { color: "disabled" }), children: options.cardTypes.map(card => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: card?.cardType, children: card.label }, card?.cardType))) })] }), (0, jsx_runtime_1.jsxs)(material_1.FormControl, { children: [(0, jsx_runtime_1.jsx)(exports.StyledFormLabel, { children: "End Date" }), (0, jsx_runtime_1.jsx)(material_1.Box, { component: "div", children: (0, jsx_runtime_1.jsxs)(LocalizationProvider_1.LocalizationProvider, { dateAdapter: AdapterDayjs_1.AdapterDayjs, children: [(0, jsx_runtime_1.jsx)(DatePicker_1.DatePicker, { value: endDateInputValue, shouldDisableDate: (date) => date.isBefore((0, dayjs_1.default)(), 'day') || date.isAfter((0, dayjs_1.default)(maxDate, purchaseRequestForm_1.DATE_FORMAT), 'day'), minDate: (0, dayjs_1.default)(), maxDate: (0, dayjs_1.default)(maxDate, purchaseRequestForm_1.DATE_FORMAT), format: purchaseRequestForm_1.DATE_FORMAT, sx: { minHeight: '40px', p: 0 }, onError: newError => {
                                                setIsDateValid(newError === null);
                                            }, onChange: value => {
                                                if (!value) {
                                                    return;
                                                }
                                                setEndDateInputValue(value);
                                                setApprovalRequest({
                                                    ...approvalRequest,
                                                    endDate: value.format(purchaseRequestForm_1.DATE_FORMAT),
                                                });
                                            } }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: { ml: 1 }, children: (0, jsx_runtime_1.jsx)("ul", { children: (0, jsx_runtime_1.jsx)("li", { children: dateMessage }) }) })] }) })] }), Object.entries(options?.codingLists)?.map(([listId, listValue]) => ((0, jsx_runtime_1.jsxs)(material_1.FormControl, { children: [(0, jsx_runtime_1.jsx)(exports.StyledFormLabel, { children: listValue?.label }), (0, jsx_runtime_1.jsx)(material_1.Select, { id: listId, value: approvalRequest.coding && approvalRequest.coding[listId]?.ID ? approvalRequest.coding[listId]?.ID : '', onChange: event => {
                                    const entry = listValue?.entries?.find(el => el.entryId === event.target.value);
                                    setApprovalRequest({
                                        ...approvalRequest,
                                        coding: {
                                            ...approvalRequest?.coding,
                                            [listId]: {
                                                ID: entry?.entryId,
                                                listId,
                                                listLabel: listValue?.label,
                                                path: entry?.label,
                                            },
                                        },
                                    });
                                }, children: listValue?.entries?.map(type => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { value: type?.entryId, children: type?.label }, type?.entryId))) }, "field-8")] }, listId)))] })] }));
    const isSubmitButtonDisabled = () => {
        const formInvalid = isFormInvalid();
        const dateInvalid = !isDateValid;
        const pauseVirtualCardCreation = features.PAUSE_VIRTUAL_CARD_CREATION;
        const teamCardCreationPaused = isTeamCardCreationPaused;
        const noCardSources = !options?.cardSources?.length;
        return formInvalid || dateInvalid || pauseVirtualCardCreation || teamCardCreationPaused || noCardSources;
    };
    const footerButtons = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "create-card-button", disabled: isSubmitButtonDisabled() || submitApprovalQuery.isPending, color: uiConstants_1.UI_BUTTON_PRIMARY, onClick: submit, label: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'Approve Card' : 'Create Card' }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "cancel-button", onClick: () => setIsCreateCardAsideOpen(false), color: uiConstants_1.UI_BUTTON_SECONDARY, label: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'Go back' : 'Cancel' })] }));
    return ((0, jsx_runtime_1.jsxs)(drawerAside_1.default, { id: "createCardAside", title: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 'Card approval request' : 'Create Card', open: isOpen, onClose: () => {
            initializeApproval();
            setIsCreateCardAsideOpen(false);
        }, footerButtons: footerButtons, children: [features.PAUSE_VIRTUAL_CARD_CREATION || isTeamCardCreationPaused ? ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "warning", children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                    ? strings_1.errorStrings.HSBC_CARD_CREATION
                    : strings_1.errorStrings.AMEX_CARD_CREATION })) : null, asideContent] }));
};
exports.default = (0, react_1.memo)(CreateCardAside);
